import { useUpdateFlow } from '../../api/useUpdateFlow'
import { Button, Text } from '@mantine/core'
import { FaultStatus } from '../../api/fault.types'

export function InitiallyReportedForm({
  id,
  status,
}: {
  id: number
  status?: FaultStatus
}) {
  const { updateFlow } = useUpdateFlow(id)
  return (
    status === FaultStatus.initially_reported && (
      <>
        <Text size='xs' mt={4}>
          Czy chcesz zaakceptować?
        </Text>
        <Button
          mt='md'
          mr='md'
          variant='filled'
          color='teal'
          onClick={() => updateFlow({ flow: 1, decision: 'accepted' })}
        >
          Zaaakceptuj
        </Button>
        <Button
          mt='md'
          mr='md'
          variant='filled'
          color='red'
          onClick={() => updateFlow({ flow: 1, decision: 'rejected' })}
        >
          Odrzuć
        </Button>
      </>
    )
  )
}
